import React from 'react';
import { Link } from 'react-router-dom';

const valori = [
  {
    icon: '🌱',
    color: '#EAF3DE',
    title: 'Riduzione dell\'Impronta Ambientale',
    desc: 'Ottimizzazione delle risorse e minore consumo energetico.',
  },
  {
    icon: '🤝',
    color: '#E6F1FB',
    title: 'Impatto Sociale Positivo',
    desc: 'Software accessibile, etico e che rispetta la privacy degli utenti.',
  },
  {
    icon: '⚖️',
    color: '#FAEEDA',
    title: 'Governance Robusta',
    desc: 'Trasparenza, sicurezza e responsabilità nel processo di sviluppo.',
  },
];

const steps = [
  {
    n: '1',
    title: 'Valutazione Dettagliata',
    desc: 'Analisi approfondita dei vostri progetti in relazione ai criteri ESG.',
  },
  {
    n: '2',
    title: 'Consulenza Esperta',
    desc: 'Forniamo indicazioni e supporto per migliorare le vostre pratiche.',
  },
  {
    n: '3',
    title: 'Certificazione Riconosciuta',
    desc: 'Rilascio di una certificazione che attesta il vostro impegno e la conformità ESG.',
  },
];

const stats = [
  { num: '500+', label: 'Progetti certificati' },
  { num: '98%', label: 'Clienti soddisfatti' },
  { num: '12+', label: 'Paesi raggiunti' },
  { num: '5', label: 'Anni di esperienza' },
];

export default function ChiSiamoPage() {
  return (
    <div style={{ background: '#F8F8F6', minHeight: '100vh' }}>
      <style>{`
        .chisiamo-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
        .chisiamo-steps { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        .chisiamo-stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
        @media (max-width: 768px) {
          .chisiamo-grid { grid-template-columns: 1fr !important; }
          .chisiamo-steps { grid-template-columns: 1fr !important; }
          .chisiamo-stats { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>

      {/* Hero */}
      <section style={{ background: '#1D9E75', padding: '64px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: 640, margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.2)', color: 'white', borderRadius: 20, padding: '4px 14px', fontSize: 12, fontWeight: 500, marginBottom: 20 }}>
            Il nostro team
          </div>
          <h1 style={{ fontSize: 40, fontWeight: 500, color: 'white', lineHeight: 1.2, marginBottom: 16 }}>
            Pionieri nella Certificazione di Software Sostenibile
          </h1>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.85)', lineHeight: 1.75, margin: 0 }}>
            Siamo un team dedicato con una profonda passione per l'innovazione tecnologica e un impegno incrollabile verso la sostenibilità.
          </p>
        </div>
      </section>

      {/* Stats bar */}
      {/* <section style={{ background: 'white', borderBottom: '1px solid #E0DED6', padding: '32px 24px' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div className="chisiamo-stats">
            {stats.map(s => (
              <div key={s.num} style={{ textAlign: 'center', padding: '8px 0' }}>
                <div style={{ fontSize: 32, fontWeight: 600, color: '#1D9E75', lineHeight: 1 }}>{s.num}</div>
                <div style={{ fontSize: 13, color: '#5C5B55', marginTop: 6 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Missione */}
      <section style={{ padding: '72px 24px', background: 'white', borderBottom: '1px solid #E0DED6' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div className="chisiamo-grid">
            {/* Illustration placeholder */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: 280, height: 280, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <div style={{ width: 200, height: 200, borderRadius: '50%', background: '#C0DD97', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ width: 120, height: 120, borderRadius: '50%', background: '#1D9E75', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: 52 }}>🌍</span>
                  </div>
                </div>
                {/* Badge ESG */}
                <div style={{ position: 'absolute', top: 16, right: 8, background: '#FAC775', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 700, color: '#085041' }}>ISO 42001</div>
              </div>
            </div>

            {/* Text */}
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>La nostra missione</div>
              <h2 style={{ fontSize: 30, fontWeight: 500, color: '#1a1a1a', lineHeight: 1.3, marginBottom: 20 }}>
                Certificare il Software Sostenibile
              </h2>
              <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, marginBottom: 16 }}>
                In un'era in cui la tecnologia permea ogni aspetto della nostra vita, crediamo fermamente che l'innovazione debba andare di pari passo con la responsabilità.
              </p>
              <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, marginBottom: 16 }}>
                La nostra missione è quella di essere il punto di riferimento per le aziende software che desiderano non solo eccellere tecnicamente, ma anche dimostrare un impatto positivo sull'ambiente, sulla società e sulla propria governance.
              </p>
              <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8 }}>
                Attraverso un processo rigoroso e trasparente, valutiamo e certifichiamo i vostri progetti software, garantendo che soddisfino i criteri ESG e fornendo una roadmap per migliorare continuamente le vostre pratiche.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Perché il software sostenibile */}
      <section style={{ padding: '72px 24px', background: '#F8F8F6', borderBottom: '1px solid #E0DED6' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Perché conta</div>
            <h2 style={{ fontSize: 30, fontWeight: 500, color: '#1a1a1a', marginBottom: 16 }}>Perché il Software Sostenibile è Cruciale</h2>
            <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, maxWidth: 680, margin: '0 auto' }}>
              Il software, pur essendo immateriale, ha un impatto tangibile. Dai consumi energetici dei data center all'etica dello sviluppo, ogni linea di codice può contribuire a un futuro più verde o meno.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
            {valori.map(v => (
              <div key={v.title} style={{ background: 'white', borderRadius: 12, border: '1px solid #E0DED6', padding: '28px 24px' }}>
                <div style={{ width: 44, height: 44, borderRadius: 10, background: v.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, marginBottom: 16 }}>{v.icon}</div>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>{v.title}</h3>
                <p style={{ fontSize: 14, color: '#5C5B55', lineHeight: 1.7, margin: 0 }}>{v.desc}</p>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 32, background: 'white', borderRadius: 12, border: '1px solid #E0DED6', padding: '24px 28px' }}>
            <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, margin: 0 }}>
              Investire nella sostenibilità del software non è solo una scelta etica, ma un <strong style={{ color: '#1a1a1a' }}>imperativo strategico</strong> che apre nuove opportunità di mercato, attira talenti e rafforza la reputazione del brand.
            </p>
          </div>
        </div>
      </section>

      {/* Approccio */}
      <section style={{ padding: '72px 24px', background: 'white', borderBottom: '1px solid #E0DED6' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#1D9E75', letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Come lavoriamo</div>
            <h2 style={{ fontSize: 30, fontWeight: 500, color: '#1a1a1a', marginBottom: 16 }}>Il Nostro Approccio alla Certificazione</h2>
            <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, maxWidth: 620, margin: '0 auto' }}>
              Abbiamo sviluppato una metodologia completa e personalizzata, progettata specificamente per le esigenze delle aziende software.
            </p>
          </div>

          <div className="chisiamo-steps">
            {steps.map((s, i) => (
              <div key={i} style={{ background: '#F8F8F6', borderRadius: 12, border: '1px solid #E0DED6', padding: '28px 24px', position: 'relative' }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#1D9E75', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 16, marginBottom: 16 }}>{s.n}</div>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: '#1a1a1a', marginBottom: 8 }}>{s.title}</h3>
                <p style={{ fontSize: 14, color: '#5C5B55', lineHeight: 1.7, margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>

          <p style={{ fontSize: 15, color: '#5C5B55', lineHeight: 1.8, textAlign: 'center', marginTop: 32 }}>
            Il nostro team è composto da esperti in sostenibilità, tecnologia e conformità, pronti ad accompagnarvi in ogni fase del percorso.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: '72px 24px' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <div style={{ background: '#1D9E75', borderRadius: 16, padding: '56px 40px', textAlign: 'center' }}>
            <h2 style={{ fontSize: 30, fontWeight: 500, color: 'white', marginBottom: 16 }}>
              Unisciti a Noi per un Futuro Sostenibile
            </h2>
            <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.85)', lineHeight: 1.75, maxWidth: 580, margin: '0 auto 32px' }}>
              Se la tua azienda software è pronta a dimostrare il suo impegno per la sostenibilità e a ottenere un vantaggio competitivo nel mercato, siamo qui per aiutarti.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/register" style={{ background: 'white', color: '#1D9E75', fontWeight: 600, fontSize: 15, padding: '13px 32px', borderRadius: 8, textDecoration: 'none' }}>
                Inizia gratuitamente
              </Link>
              <Link to="/contatti" style={{ background: 'transparent', color: 'white', fontWeight: 500, fontSize: 15, padding: '13px 32px', borderRadius: 8, textDecoration: 'none', border: '1.5px solid rgba(255,255,255,0.5)' }}>
                Contattaci →
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
